// extracted by mini-css-extract-plugin
export default {"fixedbox-container":"fixedbox-container","fixedbox-input":"fixedbox-input"};